import React from 'react';
import PropTypes from 'prop-types';
import CardsWithIcons from './cards-with-icons';

const CardsWithIconsAssembly = ({ contentfulData }) => (
  <CardsWithIcons cards={contentfulData.cards} />
);

CardsWithIconsAssembly.propTypes = {
  contentfulData: PropTypes.object,
};

export default CardsWithIconsAssembly;
